import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  ApartmentOutlined,
  FileSearchOutlined,
  MailOutlined,
  UserOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Button, Typography } from "antd";

import { useThemedLogo } from "../../theme/useThemedLogo";

const { Header, Content, Sider } = Layout;
const { Text } = Typography;

const items = [
  { label: "Dashboard", key: "", icon: <DashboardOutlined /> },
  {
    label: "Organizations",
    key: "organizations",
    icon: <ApartmentOutlined />,
  },
  {
    label: "Form logs",
    key: "form-logs",
    icon: <FileSearchOutlined />,
  },
  {
    label: "Email logs",
    key: "email-logs",
    icon: <MailOutlined />,
  },
  {
    label: "User logs",
    key: "user-logs",
    icon: <UserOutlined />,
  },
  {
    label: "Activity log",
    key: "activity-log",
    icon: <HistoryOutlined />,
  },
];

export default function AdminApp() {
  const [current, setCurrent] = useState("");
  const navigate = useNavigate();
  const logo = useThemedLogo();

  const clearAdminSession = () => {
    localStorage.removeItem("adminAccessToken");
    localStorage.removeItem("adminExpireAt");
    localStorage.removeItem("adminUser");
    navigate("/admin/login");
    setTimeout(() => window.location.reload(), 500);
  };

  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key ? `/admin/${e.key}` : "/admin");
  };

  // No NoOrganizationGate/ReactivateSession here -- the admin portal has no
  // org concept and a short-lived session, so expiry just logs out.
  useEffect(() => {
    const segments = window.location.pathname.split("/").filter(Boolean);
    setCurrent(segments[1] || "");
    const checkExpiry = () => {
      const expireAt = parseInt(localStorage.getItem("adminExpireAt"), 10);
      if (!expireAt || Date.now() > expireAt) {
        clearAdminSession();
      }
    };
    checkExpiry();
    const timer = setInterval(checkExpiry, 60000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");

  return (
    <Layout className="app-layout" hasSider>
      <Sider className="app-sidebar" trigger={null} width={240} theme="light">
        <div className="app-sidebar-inner">
          <div className="app-sidebar-brand">
            <a href="/admin" aria-label="Mailinflow Admin home">
              <img
                src={logo}
                alt="Mailinflow"
                className="app-sidebar-logo-img"
              />
            </a>
          </div>
          <nav className="app-sidebar-nav" aria-label="Admin navigation">
            <Menu
              className="app-sidebar-menu"
              theme="light"
              onClick={onClick}
              selectedKeys={[current]}
              mode="inline"
              items={items}
            />
          </nav>
        </div>
      </Sider>
      <Layout>
        <Header className="app-layout-header">
          <div className="app-header">
            <div className="app-header-left">
              <Text strong>Mailinflow Admin</Text>
            </div>
            <div className="app-header-right">
              <Text type="secondary">{adminUser.emailAddress}</Text>
              <Button onClick={clearAdminSession}>Log out</Button>
            </div>
          </div>
        </Header>
        <Content>
          <div style={{ padding: 24 }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
